import { render, staticRenderFns } from "./page-create-promocode.vue?vue&type=template&id=ec97662e&"
import script from "./page-create-promocode.vue?vue&type=script&lang=ts&"
export * from "./page-create-promocode.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-promocode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports